export default "__VITE_ASSET__CXNTmRRK__"